import React from 'react'

const Extra = () => {
  return (
    <div>Extra</div>
  )
}

export default Extra